<script setup lang="ts">
import { type Component, computed } from "vue";

import LeConcurrentLicenseNotAvailableError from "@/components/search/error-results/LeConcurrentLicenseNotAvailableError.vue";
import LeFreeSearchesUsedError from "@/components/search/error-results/LeFreeSearchesUsedError.vue";
import LeLicenseNotAvailableError from "@/components/search/error-results/LeLicenseNotAvailableError.vue";
import LeNoActiveLicensesError from "@/components/search/error-results/LeNoActiveLicensesError.vue";
import LeUserLicensesExpiredError from "@/components/search/error-results/LeUserLicensesExpiredError.vue";
import LeUserNotActivatedError from "@/components/search/error-results/LeUserNotActivatedError.vue";
import type { ErrorResults } from "@/types";

const props = defineProps<{ results: ErrorResults }>();

const errorMessageToComponentMap = {
  concurrent_license_not_available: LeConcurrentLicenseNotAvailableError,
  ip_free_searches_used: LeFreeSearchesUsedError,
  user_no_licenses_available: LeNoActiveLicensesError,
  network_no_licenses_available: LeNoActiveLicensesError,
  license_not_available: LeLicenseNotAvailableError,
  search_too_fast: undefined, // No information is displayed for this error
  user_licenses_expired: LeUserLicensesExpiredError,
  user_not_activated: LeUserNotActivatedError,
  search_view_type_not_available: undefined // This error is handled in the search store
};

const errorResultComponent = computed<Component | undefined>(() => errorMessageToComponentMap[props.results.message]);
</script>

<template>
  <Component :is="errorResultComponent" />
</template>
